export function mergeData(defaultData, responseData) {
  for (const key in defaultData) {
    if (responseData[key] === undefined || responseData[key] === null) {
      responseData[key] = defaultData[key];
    } else if (typeof responseData[key] === 'object' && !Array.isArray(responseData[key])) {
      mergeData(defaultData[key], responseData[key]);
    }
  }
  return responseData;
}
export const getFormattedDate = (date) => {
  if (!date) return "Sin definir";
  const options = {
    weekday: "long",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    timeZone: "America/Argentina/Buenos_Aires"
  };
  
  let formattedDate = new Date(date).toLocaleDateString("es-ES", options);
  formattedDate = formattedDate.replace(",", "");
  return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
};

export const getFormattedTime = (date) => {
  if (!date) return "Sin hora";
  return new Date(date).toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone: "America/Argentina/Buenos_Aires"
  });
};

export function convertirDiasAHoras(dias) {
  if (!dias || isNaN(dias)) {
    return 0;
  }

  return dias * 24;
}

export const formatNumber = (number) => {
  if (number === undefined || number === null) {
    return "0";
  }
  return number.toLocaleString("es-AR");
}

export const formatDateForBackend = (date) => {
  if (!date) return null;

  if (date instanceof Date) {
    return date.toLocaleDateString("es-AR", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
    const [year, month, day] = date.split("-");
    const localDate = new Date(year, month - 1, day);
    return localDate.toLocaleDateString("es-AR", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  }

  try {
    const d = new Date(date);
    return d.toLocaleDateString("es-AR", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      timeZone: "America/Argentina/Buenos_Aires",
    });
  } catch {
    return null;
  }
};


export const ocultarNombre = (nombre) => {
  if (!nombre || nombre.length <= 3) return "***";

  const visible = nombre.slice(0, 3) + '***';

  return visible;
}

export function convertToBase64File(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  })
}

export function calcularDiasHasta(fechaFin) {
  if (!fechaFin) return null;

  const hoy = new Date(
    new Date().toLocaleString("en-US", {
      timeZone: "America/Argentina/Buenos_Aires",
    })
  );

  const fin = new Date(
    new Date(fechaFin).toLocaleString("en-US", {
      timeZone: "America/Argentina/Buenos_Aires",
    })
  );

  if (isNaN(fin.getTime())) return null;

  const diferenciaMs = fin.getTime() - hoy.getTime();

  if (diferenciaMs <= 0) return 0;

  const horasTotales = diferenciaMs / (1000 * 60 * 60);

  if (horasTotales < 24) {
    return `${Math.floor(horasTotales)} horas`;
  }

  const dias = Math.floor(horasTotales / 24);
  return `${dias} días`;
}


export function formatearInputMoneda(value) {
  if (value === null || value === undefined || value === "") {
    return "";
  }

  let num = value.toString().replace(/[^0-9.,]/g, "");

  if (num.includes(",")) {
      return num;
  }

  return new Intl.NumberFormat("es-AR").format(Number(num));
}

export function formatearCuit(cuit){
  let cuitParVerif = cuit.substring(0, 2);
  let cuitDU = cuit.substring(2,10);
  let cuitUltimoDigito = cuit.substring(cuit.length - 1);
  return `${cuitParVerif}-${cuitDU}-${cuitUltimoDigito}`;
}


export function truncarTexto(texto) {
  if (!texto) return "";
  return texto.length > 30 ? texto.substring(0, 30) + "..." : texto;
}

export function truncarTextoTitulo(texto) {
  if (!texto) return "";
  return texto.length > 20 ? texto.substring(0, 20) + "..." : texto;
}

export function isMobile(breakpoint = 768) {
  return window.innerWidth <= breakpoint;
}

export const toLocalDate = (s) => {
  if (!s) return null;
  const iso = s.replace(" ", "T");
  const d = new Date(iso);
  return isNaN(d) ? null : d;
};
